export function capitalize(value: string) {
	return value[0]?.toUpperCase() + value?.slice(1);
}

/** For a search ignoring case and accents: " Énergie" → "energie". */
export function normalizeForSearch(value: string): string {
	return value.trim().toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '');
}
